<template>
    <Content v-if="showProducts">
        <secondary-title>Aproveite e compre também</secondary-title>
        <section :key="keyList">
            <template v-for="(product, key) in products">
                <ProductsToBuyTogetherItem
                    :key="product.id"
                    :product="product"
                    :keyProduct="key"
                />
            </template>
        </section>
        <div v-if="!hidePrice" class="products-to-buy-together-action">
            <span>
                Preço total: <big>{{ currency.money(totalPrice) }}</big>
            </span>
            <PrimaryButton type="button" @click.prevent="handleAddCart">
                <i class="icon-bag"></i>
                Adicionar ao carrinho
            </PrimaryButton>
        </div>
        <!-- <div
            class="col-12 col-sm mb-2 mt-2 d-flex flex-column align-items-center justify-content-center actions-tie-sale"
            style="min-width: 240px"
            v-if="!hidePrice"
        >
            <span>Preço total: <big>{{ currency.money(totalPrice) }}</big></span>
            <c-button
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                display="flex"
                class="paction add-cart"
                @click.prevent="handleAddCart"
            >
                <span style="font-size: 1.4rem;" class="ml-1">Adicionar ao carrinho</span>
            </c-button>
        </div> -->
    </Content>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { CSecondaryTitle } from "../../Styles/Components/styled";
import { Content } from "./style";
import ProductsToBuyTogetherItem from "../ProductsToBuyTogetherItem";
import Currency from "../../../helpers/parseCurrency";
import { PrimaryButton } from "../../Styles/Extends/styled";
import { swall } from "../../../services/sweetAlert";

export default {
    name: "ProductsToBuyTogether",
    components: {
        Content,
        ProductsToBuyTogetherItem,
        PrimaryButton,
        "secondary-title": CSecondaryTitle
    },
    data() {
        return {
            products: [],
            currency: Currency,
            selecteds: [],
            keyList: 0
        };
    },
    mounted() {
        this.item.selected_tie_sale == true;
        let item = JSON.parse(JSON.stringify(this.item));
        this.products = [
            item,
            ...this.item.tie_sale_products.filter(p => this.filterProducts(p))
        ];
    },
    methods: {
        ...mapActions("cart", ["ActionSetItemsCart", "ActionAddItemsCart"]),
        validateCart(item) {
            let qtd =
                item?.quantity_conversion_factor > item.minimum_sale_quantity
                    ? item.quantity_conversion_factor
                    : item.minimum_sale_quantity;
            let nameGrid = null;
            let itemGrid = null;

            if (item.items_grid_columns_and_rows?.column?.length) {
                nameGrid = item.items_grid_columns_and_rows.column[0].grid_group_name.toLowerCase();
                itemGrid = item.items_grid_columns_and_rows.column.find(
                    ig => ig.active
                );

                if (!itemGrid) {
                    swall(
                        `Selecione uma opção de ${nameGrid} para o produto "${item.pro_name_site}"!`,
                        true
                    );
                    return true;
                }

                if (itemGrid?.row) {
                    nameGrid = itemGrid.row[0].grid_group_name.toLowerCase();
                    itemGrid = itemGrid.row.find(ig => ig.active);

                    if (!itemGrid) {
                        swall(
                            `Selecione uma opção de ${nameGrid} para o produto "${item.pro_name_site}"!`,
                            true
                        );
                        return true;
                    }
                }
            } else {
                if (item.items_grid_columns_and_rows?.row?.length) {
                    nameGrid = item.items_grid_columns_and_rows.row[0].grid_group_name.toLowerCase();
                    itemGrid = item.items_grid_columns_and_rows.row.find(
                        ig => ig.active
                    );

                    if (!itemGrid) {
                        swall(
                            `Selecione uma opção de ${nameGrid} para o produto "${item.pro_name_site}"!`,
                            true
                        );
                        return true;
                    }
                }
            }

            this.selecteds.push({
                pro_id: item.id,
                pro_qtd: qtd,
                items_grid_id: itemGrid?.items_grid_id
            });

            return false;
        },
        async handleAddCart() {
            let selected = this.products.filter(
                p => p.selected_tie_sale // && this.filterProducts(p)
            );

            for (const el of selected) {
                let isInvalid = this.validateCart(el);
                if (isInvalid) {
                    this.selecteds.splice(0);
                    return;
                }
            }
            // console.log(this.selecteds)
            // return

            await this.ActionAddItemsCart({
                itemsCart: JSON.stringify(this.selecteds)
            })
                .then(resp => {
                    this.isLoading = false;
                    let { data } = resp;
                    this.ActionSetItemsCart(data);
                    if (this.facebookPixel?.settings?.AddToCart == true) {
                        fbq("track", "AddToCart");
                    }
                    if(this.googleAds?.id != null) {
                        gtag('event', 'add_to_cart', {
                        'pageTitle': this.company.nome_fantasia,
                        'pageCategory': 'Produto',
                        'ecommerce' : {
                            'currency': 'BRL',
                            'value': this.selecteds
                                .reduce((total, selectedProduct) => {
                                    const cartProduct = data.list.find(cartItem => cartItem.id === selectedProduct.pro_id);
                                    return total + ((cartProduct?.pro_price_site || 0) * Number(selectedProduct.pro_qtd));
                                }, 0).toFixed(2),

                            'products': this.selecteds
                                .map(selectedProduct => {
                                    const cartProduct = data.list.find(cartItem =>
                                        cartItem.id === selectedProduct.pro_id &&
                                        (!selectedProduct.items_grid_id || cartItem.items_grid_id === selectedProduct.items_grid_id)
                                    );
                                    return {
                                        'id': cartProduct?.api_cod_original || '',
                                        'name': cartProduct?.pro_name_site || '',
                                        'price': (cartProduct?.pro_price_site || selectedProduct.pro_price || 0).toFixed(2),
                                        'discount': cartProduct?.percentage_discount || 0,
                                        'quantity': Number(selectedProduct.pro_qtd) || 1,
                                        'variant': cartProduct?.items_grid_abbreviaton ??
                                                    `${cartProduct?.grid_group_column_value ?? ''}${cartProduct?.grid_group_row_value ?? ''}`
                                    };
                            })
                        }
                    });
                    }
                    this.selecteds.splice(0);
                    this.resetItemsGrid();
                    swall(
                        "Produtos adicionados ao carrinho com sucesso!",
                        false,
                        "check",
                        "success"
                    );
                })
                .catch(error => {
                    this.isLoading = false;
                    swall(error?.msg ?? error);
                });
        },
        resetItem(product) {
            product.selected_tie_sale = true;
            product.pro_price_site = product.bkp_pro_price_site;
            if (
                product?.items_grid_columns_and_rows?.column?.length ||
                product?.items_grid_columns_and_rows?.row?.length
            ) {
                if (product?.items_grid_columns_and_rows?.column?.length) {
                    product.items_grid_columns_and_rows.column.map(column => {
                        column.active = false;
                        if (column?.row) {
                            column.row.map(row => (row.active = false));
                        }
                    });
                }
                if (product?.items_grid_columns_and_rows?.row?.length) {
                    product.items_grid_columns_and_rows.row.map(
                        row => (row.active = false)
                    );
                }
            }
            // product.reset_items_grid = false
        },
        resetItemsGrid() {
            this.products.map(product => {
                product.reset_items_grid = true;
                // console.log({product})
                this.resetItem(product);

                return product;
            });
            // this.keyList++;
        },
        filterProducts(p) {
            return (
                p.sell_out_of_stock ||
                (((p.items_grid_columns_and_rows?.column?.length &&
                    p.items_grid_columns_and_rows.column.find(
                        c =>
                            c.quantity >=
                            (c.quantity_conversion_factor >
                            c.minimum_sale_quantity
                                ? c.quantity_conversion_factor
                                : c.minimum_sale_quantity)
                    )) ||
                    (!p.items_grid_columns_and_rows?.column?.length &&
                        p.items_grid_columns_and_rows?.row?.length &&
                        p.items_grid_columns_and_rows.row.find(
                            r =>
                                r.quantity >=
                                (r.quantity_conversion_factor >
                                r.minimum_sale_quantity
                                    ? r.quantity_conversion_factor
                                    : r.minimum_sale_quantity)
                        ))) &&
                    Number(p.pro_stock_site) >=
                        (Number(p.quantity_conversion_factor) >
                        Number(p.minimum_sale_quantity)
                            ? Number(p.quantity_conversion_factor)
                            : Number(p.minimum_sale_quantity)))
            );
        }
    },
    computed: {
        ...mapState("products", ["item", "minimumQuantity"]),
        ...mapState("company", ["facebookPixel", "googleAds"]),
        ...mapGetters("company", [
            "hidePriceNotLoggedUser",
            "blockAccessWhenUserNotLoggedIn"
        ]),
        totalPrice() {
            // el.selected_tie_sale == true && (el.pro_stock_site > 0 || el.sell_out_of_stock)
            return this.products
                .filter(el => el.selected_tie_sale == true)
                .map(e => (!e.price_to ? e.pro_price_site : e.price_to))
                .reduce((a, b) => +a + +b, 0);
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged;
        },
        hidePrice() {
            return !this.hidePriceNotLoggedUser
                ? false
                : this.hidePriceNotLoggedUser && !this.isLogged
                ? true
                : false;
        },
        haveProductsToBuyTogether() {
            return this.item?.tie_sale_products?.filter(p =>
                this.filterProducts(p)
            )?.length;
        },
        showProducts() {
            return (
                !(this.blockAccessWhenUserNotLoggedIn && !this.isLogged) &&
                this.haveProductsToBuyTogether
            );
        }
    }
};
</script>
